var variantSelector = document.getElementById('ProductSelect--product-template');
var listener = () => {
  variantSelector.removeEventListener('change', listener);
  var interval = setInterval(function() {
    var sealRows = document.getElementsByClassName('seal-row');
    
    if(!sealRows.length) {
      return; 
    }
    clearInterval(interval);

    sealRows[1].click();
    document.getElementById('sls').style.display = "block"

    for(var i = 2; i < sealRows.length; i++) {
      sealRows[i].parentElement.style.display = "none"
    }
  }, 50);
}
variantSelector.addEventListener('change', listener);
